import React, { useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const ProductGallery = ({ images, name }) => {
  const [active, setActive] = useState(0);
  const safeImages = images.filter(Boolean);
  const go = (direction) => setActive((current) => (current + direction + safeImages.length) % safeImages.length);

  useEffect(() => {
    setActive(0);
  }, [images, name]);

  return (
    <div className="product-gallery">
      <div className="product-gallery__main">
        <img src={safeImages[active]} alt={`${name} view ${active + 1}`} />
        {safeImages.length > 1 && (
          <div className="product-gallery__arrows">
            <button type="button" onClick={() => go(-1)} aria-label="Previous image"><FiChevronLeft /></button>
            <button type="button" onClick={() => go(1)} aria-label="Next image"><FiChevronRight /></button>
          </div>
        )}
      </div>
      {safeImages.length > 1 && (
        <div className="product-gallery__thumbs">
          {safeImages.map((image, index) => (
            <button type="button" className={active === index ? "is-active" : ""} onClick={() => setActive(index)} aria-label={`Show image ${index + 1}`} key={`${image}-${index}`}>
              <img src={image} alt="" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGallery;
